var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome04 = function SvgHome04(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 50.7856H58.2925",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84692 35.3574H11.5205V50.6146H3.84692V35.3574Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4624 21.8145H26.136V50.6145H18.4624V21.8145Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.897 33.9863H40.5705V50.6149H32.897V33.9863Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5134 27.6426H55.187V50.614H47.5134V27.6426Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68275 18.3857C5.3076 18.3857 3.29785 20.2714 3.29785 22.5C3.29785 24.7286 5.3076 26.6143 7.68275 26.6143C10.0579 26.6143 12.0676 24.7286 12.0676 22.5C12.0676 20.2714 10.2406 18.3857 7.68275 18.3857ZM22.2991 4.5C19.9239 4.5 17.9142 6.38571 17.9142 8.61429C17.9142 10.8429 19.9239 12.7286 22.2991 12.7286C24.6742 12.7286 26.684 10.8429 26.684 8.61429C26.684 6.38571 24.6742 4.5 22.2991 4.5ZM36.7327 16.8429C34.3575 16.8429 32.3478 18.7286 32.3478 20.9571C32.3478 23.1857 34.3575 25.0714 36.7327 25.0714C39.1078 25.0714 41.1176 23.1857 41.1176 20.9571C41.1176 18.7286 39.1078 16.8429 36.7327 16.8429ZM51.349 10.5C48.9739 10.5 46.9641 12.3857 46.9641 14.6143C46.9641 16.8429 48.9739 18.7286 51.349 18.7286C53.7242 18.7286 55.7339 16.8429 55.7339 14.6143C55.7339 12.3857 53.7242 10.5 51.349 10.5Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7036 18.7286L18.4637 12.3857",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1362 12.043L33.079 18.043",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1189 19.2428L46.2346 16.8428",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome04, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-04.ef57e243.svg";
export { ForwardRef as ReactComponent };